export const TPO = 'TPO';
export const Borrower = 'Borrower';
export const Broker = 'Broker';

export const CONTACTED_SUB_STATUS_C = 'Contacted (Messaged)'
export const NOT_YET_CONTACTED_SUB_STATUS_C = 'Not Yet Contacted'